/**
 * The small line pictures of the toolbar and the status bar (24×24, drawn in the text colour).
 */
import type { JSX } from "solid-js";
import type { IconName } from "./menus";

/** The SVG paths of each picture. */
const PATHS: Record<IconName, string> = {
  save: "M5 4h11l3 3v13H5zM8 4v5h7V4M8 20v-6h8v6",
  undo: "M9 7L4 12l5 5M4 12h11a5 5 0 0 1 0 10h-3",
  redo: "M15 7l5 5-5 5M20 12H9a5 5 0 0 0 0 10h3",
  add: "M12 5v14M5 12h14",
  link: "M6.5 17.5a2.5 2.5 0 1 1 0-.01M17.5 6.5a2.5 2.5 0 1 1 0-.01M8.5 15.5l7-7",
  presets: "M4 5h7v6H4zM13 5h7v6h-7zM4 13h7v6H4zM13 13h7v6h-7z",
  scan: "M4 8V4h4M16 4h4v4M20 16v4h-4M8 20H4v-4M7 12h10",
  ai: "M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM18.5 15.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z",
  plugins: "M9 4h3a2 2 0 0 1 4 0h3v5a2 2 0 0 1 0 4v6h-6a2 2 0 0 0-4 0H4v-6a2 2 0 0 0 0-4V4z",
  fit: "M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5",
  diagram: "M4 4h7v5H4zM13 15h7v5h-7zM7.5 9v4h9v2",
  cube: "M12 3l8 4.5v9L12 21l-8-4.5v-9zM12 12l8-4.5M12 12v9M12 12L4 7.5",
  windows: "M4 5h16v14H4zM4 9h16M10 9v10",
  log: "M5 6h14M5 10h14M5 14h9M5 18h11",
  search: "M10.5 4a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13zM15.5 15.5L20 20",
};

/** One picture, `size` pixels wide (default 18). */
export function Icon(props: { name: IconName; size?: number }): JSX.Element {
  return (
    <svg class="icon" width={props.size ?? 18} height={props.size ?? 18} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d={PATHS[props.name]} />
    </svg>
  );
}
